module.exports = __webpack_public_path__ + "img/enter_notice_bac.4ace022b.png";